// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGWarning = props => /*#__PURE__*/_jsx("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 28 25",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M12 7.663c-.042-.286.044-.577.234-.796.192-.218.469-.344.76-.344h2.011c.292 0 .57.126.76.344.192.22.277.51.236.796l-1.006 6.992c-.07.492-.494.857-.995.857-.5 0-.925-.365-.995-.857l-1.006-6.992zm2 13.841c-1.11 0-2.01-.894-2.01-1.997 0-1.103.9-1.998 2.01-1.998 1.111 0 2.01.895 2.01 1.998s-.899 1.997-2.01 1.997zm3.001-19.783C16.375.643 15.253 0 14 0s-2.374.643-3 1.72L.47 19.838c-.627 1.078-.627 2.365 0 3.442C1.096 24.357 2.217 25 3.47 25H24.53c1.253 0 2.374-.643 3-1.72.627-1.078.627-2.365 0-3.443L17.001 1.721z",
    fillRule: "evenodd"
  })
}));
SVGWarning.displayName = 'SVGWarning';
export default SVGWarning;